export const FORECAST_MONTHS_QTY = 6
export const ACTUALS_MONTHS_QTY = 12

export const ROWS_PER_REQUEST = 25
